<mat-card class="flex flex-col" (click)="showDetails()" fxFlex="grow" class="mat-elevation-z3">
  <div class="flex flex-col text-part" fxLayout="row" fxLayoutAlign="space-between center">
    <h4>{{ offer.title }}</h4>
    <div class="badge" *ngIf="!offer.seen">Nowa</div>
  </div>
  <div
    class="image"
    [style.backgroundImage]="'url(' + offer.imageUrl + ')'"
    [style.backgroundColor]="offer.backgroundColor || ''"
  ></div>
</mat-card>
